import {AngularFireFunctions} from "@angular/fire/functions";
import {Badge} from "../domain/badges/Badge";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {BadgesRepository} from "./repository/BadgesRepository";
import {LocalizationService} from "./LocalizationService";
import {NGXLogger} from "ngx-logger";
import {BadgeRef} from "../domain/badges/BadgeRef";
import {WaihonaUser} from "../domain/user/WaihonaUser";
import {WaihonaUserRef} from "../domain/user/WaihonaUserRef";
import {BadgeAward} from "../domain/badges/BadgeAward";
import {WaihonaUserService} from "./WaihonaUserService";

@Injectable()
export class BadgeService {

	constructor(public repo:BadgesRepository,
	            private localizationService:LocalizationService,
	            private waihonaUserService:WaihonaUserService,
	            protected logger:NGXLogger, private functions:AngularFireFunctions) {
	}

	public get store() {
		return this.repo.accessors();
	}

	public get LocalizeTools() {
		return this.localizationService.LocalizeTools;
	}

	/** Save a Badge */
	public save$(badge:Badge):Observable<Badge> {
		return this.repo.save$(badge);
	}

	/** List all Badges */
	public listBadges$(limit?:number):Observable<Badge[]> {
		return this.repo.list$();
	}

	/** List all Badges as Refs */
	public listBadgeRefs$(limit?:number):Observable<BadgeRef[]> {
		return this.repo.listAsRef$();
	}

	/** Get a single Badge */
	public getBadgeById$(guid: string):Observable<Badge> {
		return this.repo.get$(guid);
	}

	public awardBadges$(badgeGuid:string, userGuids:string[], awardLevel:number):Observable<any> {
		return this.functions.httpsCallable('awardBadge')({badgeGuid, userGuids, awardLevel});
	}

	public setAdministrators$(userGuids:string[], enabled:boolean):Observable<any> {
		return this.functions.httpsCallable('setBadgeAdministrators')({userGuids, enabled});
	}

	public awardBadgeToUser$(badgeRef:BadgeRef, user:WaihonaUserRef, awardLevel:number = 1):Observable<any> {
		return this.awardBadges$(badgeRef.guid, [user.guid], awardLevel);
	}
}
